import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Link, useNavigate } from 'react-router-dom';
import { FaAnglesLeft } from 'react-icons/fa6';
import { db } from '../../../firebase';
import Authorline from './Authorline';

const Authors = () => {
    const [authors, setAuthors] = useState([]);

    //read users data from firestore
    useEffect(() => {
        const retrieveAuthorsData = async () => {
            const authorColRef = query(collection(db, 'authors'), orderBy('createdAt', 'desc'))
            onSnapshot(authorColRef, (snapshot) => {
                setAuthors(snapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })))
            })
        }

        retrieveAuthorsData();
    }, []);

    const navigate = useNavigate();

    return (
        <>
            <section className="bg-black flex flex-col gap-[30px] px-[60px] w-full">
                <p className="font-agrandir xl:text-[24px] text-[16px] text-tangerine">Auteurs</p>


                <section className="flex pb-[30px]" id='blog'>

                    <div className="xl:flex hidden justify-start items-center">
                        <Link onClick={() => navigate(-1)} className="font-pressura flex items-center text-aqua text-[14px]">
                            <FaAnglesLeft className='text-[10px]' />
                            Back
                        </Link>
                    </div>

                </section>
                <div className="w-full flex justify-center px-[10px]">
                    <table className="w-full text-left">
                        <thead className='border-b-2 border-tangerine'>
                            <tr className='w-full flex justify-between text-white'>
                                <th hidden={true}>id</th>
                                <th className='w-1/6'>Nom</th>
                                <th className='w-2/6'>Profil</th>
                                <th className='w-1/6'>Date de création</th>
                            </tr>
                        </thead>
                        <tbody>

                            {authors.map((author) => {
                                return (
                                    <Authorline
                                        id={author.id}
                                        key={author.id}
                                        displayName={author.data.displayName}
                                        profilPicture={author.data.profilPicture}
                                        creationDate={format(author.data.createdAt.toDate(), 'dd MMMM yyyy', { locale: fr })}
                                    />
                                )
                            })}

                        </tbody>
                    </table>

                    <div className="flex flex-col gap-5 fixed bottom-10 right-[30px] ">
                        <Link to={'/dashboard/authors/addauthor'} className='bg-black text-white font-bold py-2 px-3 rounded-md'>Ajouter un auteur</Link>
                    </div>

                </div>


            </section>

        </>)
}

export default Authors